/*import { createGrid } from "ag-grid-enterprise";*/
import { createGrid } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";

export default class AgGridWrapper {
    constructor(id, mode = 0) {
        this.id = id;
        this.mode = mode;
        this.customOptions = null;
        this.targetGrid = null;
        this.targetSearch = null;
    }

    getConfig(options = null) {
        // Crea la configurazione della griglia con i dati di default relativi alla mode
        const config = JSON.parse(JSON.stringify(AgGridWrapper.DEFAULT_SETTINGS[this.mode]));
        // Imposta il formatter per la paginazione
        config.paginationNumberFormatter = function (params) {
            return params.value;
        };
        // Analizza le eventuali options passate
        if (options) {
            for (let prop in options) {
                let lAdd = true;
                // Wrappa la callback onRowClicked per salvare lo stato della griglia
                if (prop === "onRowClicked") {
                    config.onRowClicked = this.onRowClicked.bind(this, options[prop]);
                    lAdd = false;
                }
                // Wrappa la callback onRowDoubleClicked per salvare lo stato della griglia
                if (prop === "onRowDoubleClicked") {
                    config.onRowDoubleClicked = this.onRowDoubleClicked.bind(this, options[prop]);
                    lAdd = false;
                }

                if (prop === "customOptions") {
                    // Opzioni custom che devono essere gestite in modo particolare
                    this.customOptions = options[prop];

                    // Controlla l'opzione doNotshowSelection
                    if (this.customOptions?.doNotshowSelection) {
                        if (options.onGridReady) {
                            // Esiste giÃ  una callback onGridReady quindi la wrappa
                            config.onGridReady = this.onGridReady.bind(this, options.onGridReady);
                        } else {
                            // Nessuna callback onGridReady quindi la crea
                            config.onGridReady = this.onGridReady.bind(this, null);
                        }
                    }

                    if (this.customOptions?.removeOldList) {
                        // Rimuove la vecchia griglia
                        document.querySelector(".jsList")?.remove();
                        document.getElementById("filterbox")?.remove();
                    }
                }

                if (lAdd) {
                    // Aggiunge le opzioni valide (si presuppone) che ha trovato (che possono anche sovrascrivere quelle di default)
                    config[prop] = options[prop];
                }
            }
        }
        return config;
    }

    onGridReady(callback, params) {
        // Controlla l'opzione custom doNotshowSelection
        if (this.customOptions?.doNotshowSelection) {
            params.api.deselectAll();
        }
        // Se Ã¨ stata passata una callback la esegue
        if (callback) {
            callback(params);
        }
    }

    arrangeGrid(h) {
        this.targetGrid.style.height = h + "px";
    }

    onRowClicked(callback, params) {
        // Controlla l'opzione custom doNotshowSelection
        if (this.customOptions?.doNotshowSelection) {
            params.api.deselectAll();
        }
        // Salva lo stato della griglia
        this.saveState(params);
        // Esegue la callback
        callback(params);
    }

    onRowDoubleClicked(callback, params) {
        // Controlla l'opzione custom doNotshowSelection
        if (this.customOptions?.doNotshowSelection) {
            params.api.deselectAll();
        }
        // Salva lo stato della griglia
        this.saveState(params);
        // Esegue la callback
        callback(params);
    }

    saveState(params) {
        // Salva lo stato della griglia
        const gridState = params.api.getState();
        const state = {
            ...gridState,
            payload: {
                textSearch: params.api.getQuickFilter(),
            },
        };
        localStorage.setItem(this.id + "gridState", JSON.stringify(state));
    }

    init(targetGrid, targetSearch, options) {
        // Salva i riferimenti agli elementi
        this.targetGrid = targetGrid;
        this.targetSearch = targetSearch;

        // Legge l'eventuale stato precedente della griglia
        const initialState = JSON.parse(localStorage.getItem(this.id + "gridState")) || null;
        // Controlla se Ã¨ stato passato il campo di ricerca
        if (this.targetSearch) {
            // Setta i listener per la ricerca
            this.targetSearch.addEventListener("input", () => {
                this.agGrid.setGridOption("quickFilterText", this.targetSearch.value);
                //this.agGrid.setQuickFilter(this.targetSearch.value);
            });

            if (initialState?.payload?.textSearch) {
                // Ripristina l'eventuale testo di ricerca
                this.targetSearch.value = initialState.payload.textSearch;
                options.quickFilterText = initialState.payload.textSearch;
            }
        }

        // Aggiunge lo stato
        options.initialState = initialState;
        // Lo rimuove dal localStorage
        localStorage.removeItem(this.id + "gridState");

        // Prima di crere la griglia controlla i campi passati
        this.setProperType(options.columnDefs);

        this.agGrid = createGrid(targetGrid, options);
    }

    setProperType(a) {
        for (let x = 0; x < a.length; x++) {
            // Affina le opzioni
            if (a[x].width) {
                // Se Ã¨ stata passata la larghezza allora forza la cella a non essere flex
                a[x].flex = 0;
            }

            if (a[x].type === undefined || a[x].type === AgGridWrapper.TYPE_DEFAULT) {
                // Se non viene passato il tipo o Ã¨ default allora lo forza a ellipsed
                a[x].type = AgGridWrapper.TYPE_ELLIPSED;
            }
            // Fixa i type
            if (a[x].type === AgGridWrapper.TYPE_IMAGE) {
                this.setTypeImage(a[x]);
            } else if (a[x].type === AgGridWrapper.TYPE_MULTILINE) {
                this.setTypeMultiline(a[x]);
            } else if (a[x].type === AgGridWrapper.TYPE_ELLIPSED) {
                this.setTypeEllipsed(a[x]);
            } else if (a[x].type === AgGridWrapper.TYPE_DATE) {
                this.setTypeDate(a[x]);
            } else if (a[x].type === AgGridWrapper.TYPE_DATE_LOCAL_STRING) {
                this.setTypeDateLocalString(a[x]);
            } else if (a[x].type === AgGridWrapper.TYPE_TIME) {
                this.setTypeTime(a[x]);
            } else if (a[x].type == AgGridWrapper.TYPE_CTA) {
                this.setTypeAction(a[x]);
            }

            // Altre da aggiungere qui man mano

        }
    }

    setTypeAction(entry) {
        entry.cellRenderer = this.cellRendererActions.bind(this, entry);
    }

    createSingleCta(type) {
        const btn = document.createElement("button");
        btn.classList.add("sui-button", "action-btn");


        const icon = document.createElement("i");
        if (typeof type === "string") {
            icon.classList.add(type);
        }
        else {
            for (let i = 0; i < type.length; i++) {
                icon.classList.add(type[i]);

            }
        }

        btn.append(icon);

        return btn;

    }


    getActionByType(type, entry, params) {
        for (let i = 0; i < entry.actions?.length; i++) {
            let hasPerm = entry.actions[i]?.hasPermission?.call(null, params, type);
            if (entry.actions[i].type === type && hasPerm) {
                return entry.actions[i];
            }
        }

        return null;
    }

    cellRendererActions(entry, params) {
        const cont = document.createElement("div");
        cont.classList.add("customActions");

        let action = this.getActionByType(AgGridWrapper.CTA_DELETE, entry, params);
        if (action) {
            const btn = this.createSingleCta("icon-delete");
            cont.append(btn);
            btn.addEventListener("click", action.callback.bind(this, params));
        }

        action = this.getActionByType(AgGridWrapper.CTA_VIEW, entry, params);
        if (action) {
            const btn = this.createSingleCta("icon-eye");
            cont.append(btn);
            // .bind perche se facevo () => {} dovevo passare dentro () i params
            btn.addEventListener('click', action.callback.bind(this, params));
        };

        action = this.getActionByType(AgGridWrapper.CTA_SELECT, entry, params);
        if (action) {
            const btn = this.createSingleCta(["fa-regular", "fa-square"]);
            btn.id = `${params.node.rowIndex}-btn-select`
            cont.append(btn);
            btn.addEventListener("click", callSelectActionCallback.bind(null, action, params));

            function callSelectActionCallback(action, params) {
                const i = btn.querySelector("i");

                if (i.classList.contains("fa-square-check")) {
                    i.classList.remove("fa-square-check");
                    i.classList.add("fa-square");
                    action.callback.call(null, false, params);
                }
                else {
                    i.classList.add("fa-square-check");
                    i.classList.remove("fa-square");
                    action.callback.call(null, true, params);
                }
            };
        }


        action = this.getActionByType(AgGridWrapper.CTA_COPY, entry, params);
        if (action) {
            const btn = this.createSingleCta(["fa-regular", "fa-copy"]);
            cont.append(btn);
            // .bind perche se facevo () => {} dovevo passare dentro () i params
            btn.addEventListener('click', action.callback.bind(this, params));
        }

        action = this.getActionByType(AgGridWrapper.CTA_CREATE, entry, params);
        if (action) {
            const btn = this.createSingleCta(["fa-regular", "fa-square-plus"]);
            cont.append(btn);
            // .bind perche se facevo () => {} dovevo passare dentro () i params
            btn.addEventListener('click', action.callback.bind(this, params));
        }

        action = this.getActionByType(AgGridWrapper.CTA_VIEW_IMAGE, entry, params);
        if (action) {
            const a = document.createElement("a");
            a.href = params.data.UrlFull;
            a.alt = params.data.ImageCaption;
            a.target = "_blank";
            a.style = "text-decoration: none; color: #0075b0; display: block;";

            const icon = document.createElement("i");

            const text = document.createElement("textNode");
            text.innerHTML = "View Image";
            icon.classList.add("fa-solid","fa-up-right-from-square");


            a.append(text);
            a.append(icon);
            a.href = params.data.UrlFull;
            cont.append(a);
            // .bind perche se facevo () => {} dovevo passare dentro () i params
        }



        return cont;
    }

    setTypeImage(entry) {
        if (!entry.cellRenderer) {
            entry.cellRenderer = this.cellRendererImage.bind(this);
        }
    }

    cellRendererImage(params) {
        // Renderizza un'immagine in una cella con il loading
        const url = params.value;
        const div = document.createElement("span");
        const imgLoad = new Image();
        imgLoad.src = "https://gvhidra.gva.es/svn/genaro/trunk/img/cargando.gif";
        div.appendChild(imgLoad);

        const img = new Image();
        img.src = url;
        img.onload = this.showImageInCell.bind(this, img, imgLoad, div);
        return div;
    }

    showImageInCell(img, imgLoad, div) {
        imgLoad.remove();
        div.appendChild(img);
    }

    setTypeMultiline(entry) {
        entry.cellRenderer = this.cellRendererMultiline.bind(this);
        entry.autoHeight = true;
        entry.wrapText = true;
    }

    cellRendererMultiline(params) {
        //<div class='multi-line' title='${params.value}' alt='${params.value}'>${params.value}</div>`;
        const cont = document.createElement("div");
        const div = document.createElement("div");
        div.classList.add("multi-line");
        div.title = params.value;
        div.alt = params.value;
        div.innerHTML = params.value;
        cont.appendChild(div);
        return cont.innerHTML;
    }

    setTypeEllipsed(entry) {
        let clamp = AgGridWrapper.DEFAULT_ELLIPSED_CLAMP;
        if (entry.clamp) {
            clamp = entry.clamp;
        }
        if (clamp < 1) {
            clamp = 1;
        }
        if (clamp > 10) {
            clamp = 10;
        }

        if (!entry.cellRenderer) {
            entry.cellRenderer = this.cellRendererEllipsed.bind(this, clamp);
        }
        entry.autoHeight = true;
        entry.wrapText = true;
    }

    cellRendererEllipsed(clamp, params) {
        //return `<div class='ellipsed-title' title='${params.value}' alt='${params.value}'>${params.value}</div>`;

        const cont = document.createElement("div");
        if (params.value) {
            const div = document.createElement("div");
            div.classList.add("ellipsed-title");
            div.classList.add("ellipsed-title-" + clamp);
            div.title = params.value;
            div.innerHTML = params.value;
            cont.appendChild(div);

        }
        return cont.innerHTML;
    }

    setTypeDate(entry) {
        entry.filterValueGetter = (value) => {
            const dateObject = new Date(parseInt(value.data[entry.field]))
            return dateObject.toLocaleDateString("en-GB");
        };
        entry.cellRenderer = this.cellRendererDate.bind(this);
    }



    cellRendererDate(params) {
        if (params.value < 0 || params.value == "" || params.value == null) return "";
        const dateObject = new Date(parseInt(params.value));
        return dateObject.toLocaleDateString("en-GB");
    }

    setTypeTime(entry) {
        entry.cellRenderer = this.cellRendererTime.bind(this);
    }

    cellRendererTime(params) {
        if (params.value < 0 || params.value == "" || params.value == null) return "";
        const dateObject = new Date(parseInt(params.value))
        return dateObject.toLocaleTimeString();
    }

    setTypeDateLocalString(entry) {
        entry.cellRenderer = this.cellRendererDateLocalString.bind(this);
    }

    cellRendererDateLocalString(params) {
        if (params.value < 0 || params.value == "" || params.value == null) return "";
        const dateObject = new Date(parseInt(params.value));
        return dateObject.toLocaleDateString("en-GB") + " " + dateObject.toLocaleTimeString();
    }
}

AgGridWrapper.MODE_SIMPLE = 0;
AgGridWrapper.MODE_ADVANCED = 1;

AgGridWrapper.DEFAULT_SETTINGS = [
    {
        includeHiddenColumnsInQuickFilter: true,
        pagination: true,
        paginationPageSize: 50,
        scrollbarWidth: 8,
        overlayNoRowsTemplate: "No rows to show.",
        defaultColDef: {
            resizable: true,
            sortable: true,
            suppressMenu: true, // rimuove l'hambuger menu
            // getQuickFilterText: () => "",
            // Ottimizza la larghezza di tutte le colonne riempiendo tutto lo spazio disponibile
            flex: 1,
            cellClass: "ag-grid-custom-cell",
        },
        rowSelection: "single",
    },
];

AgGridWrapper.TYPE_DEFAULT = "default";
AgGridWrapper.TYPE_IMAGE = "image";
AgGridWrapper.TYPE_MULTILINE = "multiline";
AgGridWrapper.TYPE_ELLIPSED = "ellipsed";
AgGridWrapper.TYPE_DATE = "date";                       // dd/MM/yyyy
AgGridWrapper.TYPE_DATE_LOCAL_STRING = "localdate";     // dd/MM/yyyy HH:mm:ss
AgGridWrapper.TYPE_TIME = "time";                        // HH:mm:ss
AgGridWrapper.DEFAULT_ELLIPSED_CLAMP = 2;
AgGridWrapper.TYPE_CTA = "cta";


AgGridWrapper.CTA_SELECT = "cta_select";
AgGridWrapper.CTA_DELETE = "cta_delete";
AgGridWrapper.CTA_VIEW = "cta_view";
AgGridWrapper.CTA_COPY = "cta_copy";
AgGridWrapper.CTA_CREATE = "cta_create";
AgGridWrapper.CTA_VIEW_IMAGE = "cta_view_image";